// shared-components.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrintButtonComponent } from '../component/print-button/print-button.component';
import { TabHeaderComponent } from '../layout/tab-header/tab-header.component';

import { DataTableComponent } from '../component/data-table/data-table.component';
import { DateInputComponent } from '../component/date-input/date-input.component';
import { DropdownFieldComponent } from '../component/custom-dropdown/custom-dropdown.component';
import { DropdownFieldV2Component } from '../component/custom-dropdown-v2/custom-dropdown-v2.component';

@NgModule({
    declarations: [PrintButtonComponent, TabHeaderComponent, DataTableComponent],
    imports: [CommonModule, DropdownFieldComponent, DropdownFieldV2Component, DateInputComponent],
    exports: [
        PrintButtonComponent,
        TabHeaderComponent,
        DataTableComponent,
        DropdownFieldV2Component,
        DateInputComponent,
    ]
})
export class SharedComponentsModule {}
